import { useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

import { useClickAway } from 'react-use'

export default function useTweetText({ textContainerRef }) {
  const [tweetState, setTweetState] = useState({ text: null, top: 0 })

  useClickAway(textContainerRef, () => {
    setTweetState((prevState) => ({
      ...prevState,
      text: null,
    }))
  })

  const onMouseUp = (e) => {
    const top = e.clientY - textContainerRef.current.getBoundingClientRect().top

    let text = ''

    if (!window.getSelection) return
    const selObj = window.getSelection()
    text = selObj ? selObj.toString() : ''

    if (text) {
      setTweetState({
        href:
          `https://twitter.com/intent/tweet?text=${ 
          encodeURI(text) 
          }&url=${ 
          encodeURI(document.URL)}`,
        text,
        top,
      })
    } else {
      setTweetState((prevState) => ({
        ...prevState,
        text: null,
      }))
    }
  }

  useIsomorphicLayoutEffect(() => {
    const onMouseDown = () => {
      if (!window.getSelection) return

      const selObj = window.getSelection()

      if (!selObj) return
    }
    document.addEventListener('mousedown', onMouseDown)

    return () => {
      document.removeEventListener('mousedown', onMouseDown)
    }
  }, [])

  return { onMouseUp, tweetState }
}
